(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let observer;
    const measurePromotion = () => {
      observer?.disconnect();
      const bar = document.querySelector('#header-group .announcement-bar--single');
      const section = bar?.closest('.shopify-section');
      if (!section) {
        document.documentElement.style.removeProperty('--ark-promo-height');
        return;
      }
      const updateHeight = () => {
        document.documentElement.style.setProperty('--ark-promo-height', `${section.getBoundingClientRect().height}px`);
      };
      updateHeight();
      observer = new ResizeObserver(updateHeight);
      observer.observe(section);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', measurePromotion, { once: true });
    } else {
      measurePromotion();
    }
    document.addEventListener('shopify:section:load', measurePromotion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
